export default "__VITE_ASSET__00566adf__"